import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import AboutUsPage from "./pages/AboutUsPage";
import HomePage from "./pages/HomePage";
import ContactUsPage from "./pages/ContactUsPage";
import { Provider } from "react-redux";
import store from "./store/store";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import NotFoundPage from "./pages/NotFoundPage";
import SolutionDetailsPage from "./pages/SolutionDetailsPage";
import DynamicPage from "./pages/DynamicPage";
import ContactControlPage from "./pages/ContactControlPage";
import { ContactSettingsProvider } from "./data/ContactSettingsContext";

const SiteRoutes: React.FC = () => {
  const isControlPage = useLocation().pathname === "/admin";
  return (
    <>
      {!isControlPage && <Header />}
      <Routes>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/admin" element={<ContactControlPage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/:pageType" element={<DynamicPage />} />
        <Route path="/:pageType/:solutionId" element={<SolutionDetailsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      {!isControlPage && <Footer />}
    </>
  );
};

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <ContactSettingsProvider>
        <Router>
          <SiteRoutes />
        </Router>
      </ContactSettingsProvider>
    </Provider>
  );
};

export default App;
